/* @flow */
import * as transactionsActions from './actions';
import {fromJS, Record, List} from 'immutable';

const State = Record({
    page: 0,
    limit: 8,
    max: 0,
    transactions: null,
    transaction: null,
    transactionTypes: {
        INCOME: 'INCOME',
        OUTCOME: 'OUTCOME',
        TRANSFER: 'TRANSFER'
    },
    transactionType: null,
    visibleFormPopup: false
});

const PAGE = 'page';
const TRANSACTIONS = 'transactions';
const TRANSACTION = 'transaction';
const MAX = 'max';
const POPUP_TYPE = 'popupType';
const TRANSACTION_TYPE = 'transactionType';
const VISIBLE_FORM_POPUP = 'visibleFormPopup';

const transactionsReducer = (state = new State(), action) => {

    switch (action.type) {

        case transactionsActions.ADD_BAR_REPORT_TRANSACTION_ERROR: {
            return state.set(VISIBLE_FORM_POPUP, false);
        }

        case transactionsActions.BAR_REPORT_TRANSACTION_VISIBLE_FORM: {
            const {visible} = action.payload;
            return state.set(VISIBLE_FORM_POPUP, visible);
        }

        case transactionsActions.BAR_REPORT_TRANSACTION_TYPE: {
            const {type} = action.payload;
            return state
                .set(TRANSACTION_TYPE, type)
                .set(POPUP_TYPE, 'NEW_TRANSACTION');
        }

        case transactionsActions.FETCH_BAR_REPORT_TRANSACTIONS_ERROR:
        case transactionsActions.CLEAR_BAR_REPORT_TRANSACTIONS: {
            return state
                .set(TRANSACTION, null)
                .set(PAGE, 0)
                .set(TRANSACTIONS, List())
                .set(MAX, 0);
        }

        case transactionsActions.ADD_BAR_REPORT_TRANSACTION_SUCCESS:
        case transactionsActions.DELETE_BAR_REPORT_TRANSACTION_SUCCESS:
        case transactionsActions.FETCH_BAR_REPORT_TRANSACTIONS_SUCCESS: {
            const {page, transactions, max} = action.payload.data;
            return state
                .set(PAGE, page)
                .set(TRANSACTIONS, fromJS(transactions))
                .set(MAX, max)
                .set(VISIBLE_FORM_POPUP, false);
        }

    }

    return state;
};

export default transactionsReducer;


// WEBPACK FOOTER //
// ./src/common/menu/report/transaction/reducer.js